import { useModal } from '@pcmp/react-providers';

export const useModalGoToProfile = () => {
  const { openModal, closeModal } = useModal();

  const goBack = async () => {
    await closeModal(0);
    // This dynamic import removes cyclic dependencies
    await openModal({
      component: await import('../../components/siders/user-profile').then(
        (m) => m.UserProfileSider
      ),
      props: {},
    });
  };

  return goBack;
};
